import axios from "axios";
import * as siteConfig from '../config';

const API = axios.create({
    baseURL: siteConfig.default.apiBaseURL,
    timeout: siteConfig.default.apiTimeout,
    xsrfHeaderName: "X-CSRFToken",
    xsrfCookieName: "csrftoken",
    credentials: true,
})

API.interceptors.request.use(
    (config) => {
        // ✅ division_id auto-attach हटा दिया गया है
        // जिस API में division_id चाहिए, वहाँ manually params में भेजें
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

API.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.clear();
            if (window.location.pathname !== "/" && window.location.pathname !== "/register") {
                window.location.href = "/";
            }
        }
        return Promise.reject(error);
    }
);

export default API;